<template>
    <div>
        <v-app>
            <v-dialog v-model="showAddDialog" max-width="80%">
                <v-form lazy-validation @submit.prevent="confirm">
                    <v-card class="window-card">
                        <v-card-title>
                            <span class="md-title" style="color: #67ad5b">新增系统元件动作</span>
                        </v-card-title>
                        <v-card-text>
                            <v-text-field v-model="form.name" label="动作名称 *" :rules="[v => !!v || '动作名称不能为空']"></v-text-field>
                            <v-select v-model="form.template" :items="templateListData" item-text="name" item-value="value" label="动作模板 *" :rules="[v => !!v || '动作模板不能为空']"></v-select>
                            <v-select v-model="form.uitype" :items="uitypeData" item-text="name" item-value="value" label="UI界面 *" :rules="[v => !!v || 'UI界面不能为空']" v-if="form.template === 'dkui' || form.template === 'gbui'"></v-select>
                            <v-text-field v-model="form.tipContent" label="提示内容 *" :rules="[v => !!v || '提示内容不能为空']" v-if="form.template === 'dkui' && form.uitype === 'ts'"></v-text-field>
                            <v-text-field v-model="form.formType" label="表单类型 *" :rules="[v => !!v || '表单类型不能为空']" v-if="form.template === 'dkbd'" name="formtype_v"></v-text-field>
                            <v-text-field v-model="form.formName" label="表单名称 *" :rules="[v => !!v || '表单名称不能为空']" v-if="form.template === 'dkbd'" name="forname_v"></v-text-field>
                            <v-text-field v-model="form.videoName" label="视频名称 *" :rules="[v => !!v || '视频名称不能为空']" v-if="form.template === 'dksp'"></v-text-field>
                            <v-text-field v-model="form.videoTime" label="播放时长(秒) *" :rules="[v => !!v || '播放时长(秒)不能为空']" v-if="form.template === 'dksp'"></v-text-field>
                            <v-text-field v-model="form.audioName" label="播放时长(秒) *" :rules="[v => !!v || '播放时长(秒)不能为空']" v-if="form.template === 'bfyp'"></v-text-field>
                            <v-text-field v-model="form.audioTime" label="播放时长(秒) *" :rules="[v => !!v || '播放时长(秒)不能为空']" v-if="form.template === 'bfyp'"></v-text-field>
                            <v-text-field v-model="form.delayTime" label="延时时长(秒) *" :rules="[v => !!v || '延时时长(秒)不能为空']" v-if="form.template === 'ys'"></v-text-field>
                            <v-radio-group v-model="form.type">
                                <v-radio label="动态参数：允许在任务中进行动态设置" value="dynamic"></v-radio>
                                <v-radio label="静态参数：固定在当前定义的动作内部" value="static"></v-radio>
                            </v-radio-group>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="success" type="submit">确定</v-btn>
                            <v-btn color="success" @click="cancel">关闭</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-form>
            </v-dialog>
        </v-app>
    </div>
</template>
<script>
import { SlideYDownTransition } from 'vue2-transitions'
import { extend } from 'vee-validate'
import { required, required_if } from 'vee-validate/dist/rules'

extend('required', required)
extend('required_if', required_if)
export default {
    props: {
        showAddDialog: {
            type: Boolean,
            default: false
        },
        index: {
            type: Number,
            default: -1
        },
        formData: {
            type: Object,
            default: () => {}
        }
    },
    components: {
        SlideYDownTransition
    },
    watch: {
        formData(val) {
            this.form = val
        }
    },
    data() {
        return {
            templateListData: [
                { value: 'dkui', name: '打开UI' },
                { value: 'gbui', name: '关闭UI' },
                { value: 'dkbd', name: '打开表单' },
                { value: 'dksp', name: '打开视频' },
                { value: 'bfyp', name: '播放音频' },
                { value: 'ys', name: '延时' }
            ],
            uitypeData: [
                { value: 'qr', name: '确认界面' },
                { value: 'ts', name: '提示界面' }
            ],
            lockview: '',
            form: {}
        }
    },
    methods: {
        confirm() {
            const time = new Date().getTime()
            if (this.index === -1 || !this.form.id) {
                this.form.id = `sys_${time}`
                this.form.create_time = time
            } else {
                this.form.update_time = time
            }
            this.$emit('handleConfirm', {
                form: this.form,
                index: this.index
            })
        },
        cancel() {
            this.$emit('handleCancel', {})
        }
    }
}
</script>
<style>
.window-card {
    box-shadow: 0 0px 0px 0 rgb(0 0 0 / 14%) !important;
}
</style>